import { useEffect, useState } from "react";
import { Download, FileArchive } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";

function responseFilename(headers) {
  const disposition = headers?.["content-disposition"] || "";
  const match = disposition.match(/filename\*?=(?:UTF-8''|\")?([^\";]+)/i);
  return match ? decodeURIComponent(match[1].trim()) : "invict_codigo.zip";
}

async function downloadError(error) {
  const detail = error?.response?.data;
  if (detail instanceof Blob) {
    try {
      const parsed = JSON.parse(await detail.text());
      if (parsed?.detail) return parsed.detail;
    } catch {}
  }
  return formatApiError(error);
}

export const CodeExportCard = () => {
  const [available, setAvailable] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let active = true;
    api.get("/admin/code-export/available")
      .then(({ data }) => { if (active) setAvailable(data?.available === true); })
      .catch(() => { if (active) setAvailable(false); });
    return () => { active = false; };
  }, []);

  const download = async () => {
    setBusy(true);
    try {
      const response = await api.get("/admin/code-export", { responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = responseFilename(response.headers);
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
      toast.success("Código descargado sin claves");
    } catch (error) {
      toast.error(await downloadError(error));
    } finally {
      setBusy(false);
    }
  };

  if (!available) return null;

  return (
    <section className="card" style={{ padding: 16, marginTop: 16 }} data-testid="profile-code-export-card">
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
        <FileArchive size={18} style={{ color: "#BF3437" }} />
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 800, color: "#0A0A0A" }} data-testid="profile-code-export-title">
          Código de la plataforma
        </h3>
      </div>
      <button
        type="button"
        className="btn-primary"
        onClick={download}
        disabled={busy}
        style={{ marginTop: 10, display: "inline-flex", alignItems: "center", gap: 8 }}
        data-testid="profile-code-export-download"
      >
        <Download size={16} />
        {busy ? "Preparando…" : "Descargar código (sin claves)"}
      </button>
      <p style={{ margin: "10px 0 0", fontSize: 12, color: "var(--invict-text-muted)" }} data-testid="profile-code-export-note">
        Uso interno de Olimpo. No incluye archivos .env ni claves.
      </p>
    </section>
  );
};
